import React, { useEffect, useState } from 'react'

//import logo from 'background-image: url(../../../images/mirea/logo.png)'
import {
  AboutPrograms,
  AskAndQuestions,
  BioTechPark,
  FiveStepsMirea,
  InfoBlockMirea,
  InfoProduct,
  InterestingAndForm,
  MireaSlider,
  OurCurators,
  StudentsAboutMirea
} from './index'

import styles from './styles.module.scss'
import smoothscroll from 'smoothscroll-polyfill'

const Mirea = ({ ourRef, checkDomenNameState, captchaSiteKey }) => {
  smoothscroll.polyfill()
  const [checkRef, setCheckRef] = useState('')

  useEffect(() => {
    if (ourRef) {
      ourRef?.current.scrollIntoView()
    }
  }, [])

  const watchForm = () => {
    if (checkRef) {
      checkRef?.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_img}></div>
      <InfoBlockMirea watchForm={watchForm} />
      <AboutPrograms />
      <MireaSlider />
      {/*<OurCurators />*/}
      <InfoProduct />
      <FiveStepsMirea />
      <StudentsAboutMirea />
      <BioTechPark />
      <AskAndQuestions />
      <InterestingAndForm checkDomenNameState={checkDomenNameState} setCheckRef={setCheckRef} captchaSiteKey={captchaSiteKey} />
    </div>
  )
}

export default Mirea
